<template>
  <b-card
    no-body
  >
    <b-card-body>
      <b-card-title>Permissões</b-card-title>
      <b-card-sub-title>Permissão de acordo com as funções</b-card-sub-title>
    </b-card-body>
    <b-table
      responsive
      :items="userPermissionData"
      class="mb-0"
    >

      <template #cell(module)="data">
        {{ data.value }}
      </template>
      <template #cell()="data">
        <b-form-checkbox
          disabled
          :checked="data.value"
        />
      </template>

    </b-table>
  </b-card>
</template>

<script>
import {
  BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox,
} from 'bootstrap-vue'
import store from '@/store'
import router from '@/router'
import userStoreModule from '@/views/App/Usuarios/userStoreModule'
import { ref, onUnmounted } from '@vue/composition-api'

export default {
  components: {
    BCard, BTable, BCardBody, BCardTitle, BCardSubTitle, BFormCheckbox,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const userPermissionData = ref(null)

    const USER_APP_STORE_MODULE_NAME = 'app-user'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    store.dispatch('app-user/get_permissionUserById', { id: router.currentRoute.params.id })
      .then(response => { userPermissionData.value = response.data })
      .catch(error => {
        if (error.response.status === 404) {
          userPermissionData.value = undefined
        }
      })

    // eslint-disable-next-line no-unreachable
    return {
      userPermissionData,
    }
  },
}
</script>

<style>

</style>
